import { useState, useEffect } from 'react';

const useAllFreeDeliveryProducts = () => {
  const [allFreeDeliveryProducts, setAllFreeDeliveryProducts] = useState([]);
  const [loading1, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNewProducts = async () => {
      try {
        // const response = await fetch(`/api/getAllProduct`);
        const response = await fetch(`https://backend.nuhababy.com/getAllFreeDeliveryProduct`);
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setAllFreeDeliveryProducts(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNewProducts();
  }, []);

  return { allFreeDeliveryProducts, loading1, error };
};

export default useAllFreeDeliveryProducts;